import { render, staticRenderFns } from "./OrganizationPeerGroupPackets.vue?vue&type=template&id=0ea7e262&"
import script from "./OrganizationPeerGroupPackets.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupPackets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports